import { call, select, put } from 'redux-saga/effects';

import { completeEnrollment } from '../../actions/enrollment';
import { setOrganizationCreated } from '../../effects/organization';
import { callAPI, METHODS } from '../api';
import { RESOURCES } from '../../../helpers/constants';
import { updateToken } from '../../actions/user';
import { updateUser } from '../../effects/user';

export default function* createOrganization(action) {
  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const url = `${dpaApiBaseUrl + RESOURCES.ORGA3}`;
  try {
    const { success, error, result } = yield call(callAPI, {
      url,
      method: METHODS.POST,
      body: { ...action.payload },
    });
    if (success) {
      if (success && !error) {
        yield put(updateToken());
        yield put(
          setOrganizationCreated({
            created: true,
            name: result.name,
            uuid: result.uuid,
            orgType: result.orgType,
            createdDate: result.createdDate,
          }),
        );
        yield put(
          updateUser({
            signUpRole: action.payload?.customerDataProperties?.role,
            productInterest: action.payload?.customerDataProperties?.what__c,
          }),
        );
        yield put(completeEnrollment());
      }
    } else {
      yield put(setOrganizationCreated({ error: true }));
    }
  } catch (e) {
    console.error(e);
    yield put(setOrganizationCreated({ error: true }));
  }
}
